import React, { useState, useEffect } from 'react';
import DocumentsVerificationSC from './documents-verification.styled';
import DocumentCheck from '../../ui/document-check';
import PropTypes from 'prop-types';
import InlineLoading from '../../ui/inline-loading';
import { LS_ACCESS_TOKEN } from '../../../constants';
import { BodyText } from '../../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';

const DocumentsVerification = ({ title, documents, setDocumentsToAllRead }) => {
  const [documentDatas, setDocumentDatas] = useState([]);

  useEffect(() => {
    if (Array.isArray(documents)) {
      setDocumentDatas(documents);
    } else {
      setDocumentDatas([documents]);
    }
    if (documents === null) {
      setDocumentDatas(null);
    }
  }, [documents]);

  const changeToActive = (docId, docLink) => {
    window.open(
      `${process.env.REACT_APP_WISHMAKER_API_URI}${
        process.env.REACT_APP_DOC_SLUG
      }/${docLink}?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`
    );
    const newDocumentDatas = documentDatas.map((doc) =>
      doc.id === docId ? { ...doc, active: true } : doc
    );
    setDocumentDatas(newDocumentDatas);
    if (newDocumentDatas.every((doc) => doc.active === true)) {
      setDocumentsToAllRead(true);
    }
  };

  if (documentDatas === null)
    return (
      <DocumentsVerificationSC className="empty">
        <InlineLoading />
      </DocumentsVerificationSC>
    );

  return (
    <DocumentsVerificationSC>
      {title ? (
        <div className="heading-block">
          <BodyText className="bolder">
            <FormattedMessage id={title} defaultMessage={dlt[`${title}`]} />
          </BodyText>
          <div className="separator"></div>
        </div>
      ) : null}
      <div>
        {documentDatas.map((doc) => {
          return (
            <DocumentCheck
              key={doc.id}
              onClick={() => changeToActive(doc.id, doc.url)}
              title={doc.name}
            />
          );
        })}
      </div>
    </DocumentsVerificationSC>
  );
};

DocumentsVerification.propTypes = {
  title: PropTypes.string,
  documents: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  setDocumentsToAllRead: PropTypes.func,
};

DocumentsVerification.defaultProps = {
  title: null,
  documents: [],
  setDocumentsToAllRead: () => {},
};

export default DocumentsVerification;
